export default __webpack_public_path__ + "static/media/AICounselling.c356c9343fa886aa5e1fb216a57b93ab.webp";